import React from 'react';

const Terms: React.FC = () => (
  <div className="max-w-2xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
    <h1 className="text-3xl font-bold mb-6 text-center">Terms of Service</h1>
    <p className="text-sm text-gray-500 text-center mb-8">Last Updated: May 15, 2025</p>
    <pre className="whitespace-pre-wrap text-left text-gray-800 bg-white p-4 rounded shadow overflow-x-auto text-sm">
{`
TERMS OF SERVICE
LAST UPDATED: May 15, 2025
1. ACCEPTANCE OF TERMS

By accessing or using WeTrackSSL (the "Service"), you ("Customer", "you", or "your") acknowledge that you have read, understood, and agree to be bound by these Terms of Service ("Terms"). These Terms constitute a binding contract between you and WeTrackSSL.
2. DEFINITIONS

For the purposes of these Terms:

    "Account" means the Customer account created to access the Service
    "Content" means all materials, data, and information submitted to the Service
    "Service" means the SSL certificate monitoring and reminder services provided by WeTrackSSL
    "Subscription" means the recurring payment plan selected by Customer
    "User" means anyone who accesses or uses the Service

3. USE OF THE SERVICE

3.1 Eligibility

    You must be at least 18 years old to use the Service
    You must provide accurate and complete registration information
    You must not use the Service for any unlawful purpose

3.2 Account Requirements

    One account per Customer
    Keep login credentials confidential
    Notify us immediately of any unauthorized use
    Keep account information up to date

4. SUBSCRIPTION AND PAYMENT TERMS

4.1 Subscription Plans

    Various plans available with different features and pricing
    Plans may include trial periods
    Features and pricing subject to change

4.2 Payment Processing

    Payments processed through Stripe
    Recurring billing on subscription anniversary date
    Valid payment method required at all times
    Automatic renewal unless cancelled

4.3 Pricing and Charges

    Prices listed exclude taxes and fees
    Applicable taxes added to invoices
    Currency as indicated on the pricing page
    Changes to pricing require 30-day advance notice

5. INTELLECTUAL PROPERTY

5.1 Ownership

    WeTrackSSL retains all rights to the Service
    Customer retains ownership of their Content
    No intellectual property rights transferred

5.2 License Grant

    Limited license to use the Service
    License terminates upon account closure
    Must comply with all applicable laws

6. RESPONSIBILITIES

6.1 Customer Responsibilities

    Use the Service lawfully and ethically
    Maintain security of account credentials
    Provide accurate domain information
    Comply with all applicable laws

6.2 Service Level

    Reasonable efforts to maintain uptime
    Scheduled maintenance with notice
    No guarantee against occasional downtime

7. TERMINATION

7.1 By Customer

    Cancel subscription at any time
    Cancellation takes effect at next billing cycle
    No refunds for partial periods

7.2 By WeTrackSSL

    Upon breach of these Terms
    Non-payment of fees
    Unauthorized use of the Service
    Thirty (30) days' written notice for convenience

8. WARRANTY DISCLAIMER

THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NONINFRINGEMENT.
9. LIMITATION OF LIABILITY

IN NO EVENT SHALL SSLREMINDME BE LIABLE FOR:

    ANY INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES
    AMOUNTS EXCEEDING THE TOTAL FEES PAID IN THE PRECEDING TWELVE MONTHS
    DAMAGES CAUSED BY THIRD PARTY SERVICES
    CERTIFICATE EXPIRATION OR SECURITY BREACHES

10. INDEMNIFICATION

You agree to indemnify, defend, and hold harmless WeTrackSSL, its officers, directors, employees, agents, licensors, and suppliers from and against all claims, losses, expenses, damages, and costs resulting from:

    Your violation of these Terms
    Any activity related to your account
    Your Content
    Your breach of applicable laws

11. GOVERNING LAW

These Terms shall be governed by and construed in accordance with the laws of [STATE/COUNTRY]. Any disputes arising out of or related to these Terms shall be resolved through binding arbitration in accordance with the rules of [ARBITRATION ASSOCIATION].
12. CHANGES TO THESE TERMS

We reserve the right to modify these Terms at any time. Changes become effective thirty (30) days after posting. Continued use of the Service after changes constitutes acceptance of the revised Terms.
13. CONTACT INFORMATION

For questions regarding these Terms, please contact:

    [Email Address]
    [Physical Address]
`}
    </pre>
  </div>
);

export default Terms;
